import { IActionDefinitionDto } from "@kuika/kuika-cl-model";
import { PartialContextProvider } from "../../../shared/patial/partial-context-provider";
import { IScreenDesignContextState } from "../screen-design-context";
import { IScreenDesignContextProviderProps, ScreenDesignContextProvider } from "../screen-design-context-provider";

export interface QueryBuilderProviderState {
  queryBuilderAction: IActionDefinitionDto;
  queryBuilderSql: string;
  queryBuilderIsOpen: boolean;
  editingQuery: string;
  isNewQuery: boolean;
  highlightedQuery: string;
  callbackQueryBuilder: (sql: string) => void;
  queryBuilderActionEdit: (
    action: IActionDefinitionDto,
    editingQuery: string,
    callbackQueryBuilder: (sql: string) => void
  ) => void;
  setQueryBuilderSqlResult: (sql: string) => void;
  closeQueryBuilder: () => void;
  setIsNewQuery: (isNewQuery: boolean, query?: string) => void;
}

export class QueryBuilderProvider extends PartialContextProvider<
  ScreenDesignContextProvider,
  IScreenDesignContextProviderProps,
  IScreenDesignContextState,
  QueryBuilderProviderState
> {
  static defaultState: QueryBuilderProviderState = {
    queryBuilderAction: {} as IActionDefinitionDto,
    queryBuilderSql: "",
    queryBuilderIsOpen: false,
    editingQuery: "",
    isNewQuery: false,
    highlightedQuery: "",
    callbackQueryBuilder: () => {},
    queryBuilderActionEdit: () => {},
    setQueryBuilderSqlResult: () => {},
    closeQueryBuilder: () => {},
    setIsNewQuery: () => {}
  };

  getProviderValues = (): QueryBuilderProviderState => {
    return {
      queryBuilderAction: this.state.queryBuilderAction,
      queryBuilderSql: this.state.queryBuilderSql,
      queryBuilderIsOpen: this.state.queryBuilderIsOpen,
      editingQuery: this.state.editingQuery,
      isNewQuery: this.state.isNewQuery,
      highlightedQuery: this.state.highlightedQuery,
      callbackQueryBuilder: this.state.callbackQueryBuilder,
      queryBuilderActionEdit: this.queryBuilderActionEdit,
      setQueryBuilderSqlResult: this.setQueryBuilderSqlResult,
      closeQueryBuilder: this.closeQueryBuilder,
      setIsNewQuery: this.setIsNewQuery
    };
  };

  queryBuilderActionEdit = (
    action: IActionDefinitionDto,
    editingQuery: string,
    callbackQueryBuilder: (sql: string) => void
  ) => {
    this.setState({
      queryBuilderAction: action,
      editingQuery,
      callbackQueryBuilder,
      queryBuilderIsOpen: true
    });
  };

  setQueryBuilderSqlResult = (sql: string) => {
    if (this.state.isNewQuery && this.state.queryBuilderAction.statement) {
      this.state.callbackQueryBuilder(`${this.state.queryBuilderAction.statement}\r\n${sql}`);
    } else this.state.callbackQueryBuilder(sql);
    this.setState({
      queryBuilderSql: sql,
      queryBuilderAction: undefined,
      callbackQueryBuilder: undefined,
      queryBuilderIsOpen: false,
      highlightedQuery: undefined
    });
    localStorage.removeItem("queryBuilderToken");
  };

  closeQueryBuilder = () => {
    this.setState({ queryBuilderIsOpen: false, highlightedQuery: undefined });
    localStorage.removeItem("queryBuilderToken");
  };

  setIsNewQuery = (isNewQuery: boolean, highlightedQuery?: string) => {
    if (highlightedQuery) {
      this.setState({ isNewQuery, highlightedQuery });
    } else {
      this.setState({ isNewQuery });
    }
  };
}
